import { render, staticRenderFns } from "./PayoutTagProductsForm.vue?vue&type=template&id=073472f0&"
import script from "./PayoutTagProductsForm.vue?vue&type=script&lang=js&"
export * from "./PayoutTagProductsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports